import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPageCheck"><Path d="M20 2H4V22H12.9701L10.0684 19.0658L13.268 15.9015L15.2413 17.8969L20 12.123V2Z" fill="currentColor"/><Path d="M21.8058 14.6482L20.6482 13.6942L15.3422 20.1322L13.2559 18.0225L12.1894 19.0773L15.4435 22.3678L21.8058 14.6482Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageCheck;
